// extracted by mini-css-extract-plugin
module.exports =  {"link-button":"a10a3f92e9--link-button--ujZuh"};